import {MarginMethod} from "./CommonConstants";
import {PlayerSettingsObject} from "../@types/response";

const PREFIX = 'PLAYER'

enum PlayerConstants {
    PLAYER_INITIALIZE,
    PLAYER_INITIALIZE_SUCCESS,
    PLAYER_INITIALIZE_ERROR,
    STORE_PLAYER_INITIALIZE,
    GET_SETTINGS,
    GET_SETTINGS_SUCCESS,
    DELETE_SETTINGS,
    DELETE_SETTINGS_SUCCESS,
    GET_PLAYERS,
    GET_PLAYERS_SUCCESS,
    PLAYER_EVENT,
    CLEAR_PLAYER_EVENT,
    NEW_BOOKED_EVENT,
    BOOK_EVENT,
    BOOK_EVENT_SUCCESS,
    BOOK_EVENT_ERROR,
    GET_EVENT,
    GET_EVENT_SUCCESS,
    DELETE_ALERT,
    DELETE_ALERT_SUCCESS,
    HIDE_ALERT,
    HIDE_ALERT_SUCCESS,
    NEW_HIDDEN_ALERT,
    GET_PLAYER_ODDS_EVENTS,
    GET_EVENTS,
    ADD_TO_BLACKLIST,
    SET_SETTINGS_AVERAGE_BOOKMAKERS,
    GET_ACTIVE_PLAYERS,
    SET_ACTIVE_PLAYERS,
}

const SETTINGS = 'PLAYER_SETTINGS'

enum SettingConstants {
    SET_ORDER,
    SET_SPORT_FILTER,
    SET_SETTINGS,
}

export enum OrderConstants {
    NONE,
    DATE,
    MARGIN,
    MARGIN_REV,
    COMPARISON,
    BOOK,
}

export const STORE_PLAYER_INITIALIZE = PREFIX + '_' + PlayerConstants.STORE_PLAYER_INITIALIZE;
export const PLAYER_INITIALIZE = PREFIX + '_' + PlayerConstants.PLAYER_INITIALIZE;
export const PLAYER_INITIALIZE_SUCCESS = PREFIX + '_' + PlayerConstants.PLAYER_INITIALIZE_SUCCESS;
export const PLAYER_INITIALIZE_ERROR = PREFIX + '_' + PlayerConstants.PLAYER_INITIALIZE_ERROR;
export const GET_SETTINGS = PREFIX + '_' + PlayerConstants.GET_SETTINGS;
export const GET_SETTINGS_SUCCESS = PREFIX + '_' + PlayerConstants.GET_SETTINGS_SUCCESS;
export const DELETE_SETTINGS = PREFIX + '_' + PlayerConstants.DELETE_SETTINGS;
export const DELETE_SETTINGS_SUCCESS = PREFIX + '_' + PlayerConstants.DELETE_SETTINGS_SUCCESS;

export const GET_ACTIVE_PLAYERS = PREFIX + '_' + PlayerConstants.GET_ACTIVE_PLAYERS;
export const SET_ACTIVE_PLAYERS = PREFIX + '_' + PlayerConstants.SET_ACTIVE_PLAYERS;
export const GET_PLAYERS = PREFIX + '_' + PlayerConstants.GET_PLAYERS;
export const GET_PLAYERS_SUCCESS = PREFIX + '_' + PlayerConstants.GET_PLAYERS_SUCCESS;
export const PLAYER_EVENT = PREFIX + '_' + PlayerConstants.PLAYER_EVENT;
export const CLEAR_PLAYER_EVENT = PREFIX + '_' + PlayerConstants.CLEAR_PLAYER_EVENT;

export const GET_PLAYER_ODDS_EVENTS = PREFIX + '_' + PlayerConstants.GET_PLAYER_ODDS_EVENTS;

export const GET_EVENT = PREFIX + '_' + PlayerConstants.GET_EVENT;
export const GET_EVENT_SUCCESS = PREFIX + '_' + PlayerConstants.GET_EVENT_SUCCESS;

export const BOOK_EVENT = PREFIX + '_' + PlayerConstants.BOOK_EVENT;
export const BOOK_EVENT_SUCCESS = PREFIX + '_' + PlayerConstants.BOOK_EVENT_SUCCESS;
export const BOOK_EVENT_ERROR = PREFIX + '_' + PlayerConstants.BOOK_EVENT_ERROR;

export const NEW_BOOKED_EVENT = PREFIX + '_' + PlayerConstants.NEW_BOOKED_EVENT;
export const DELETE_ALERT = PREFIX + '_' + PlayerConstants.DELETE_ALERT;
export const DELETE_ALERT_SUCCESS = PREFIX + '_' + PlayerConstants.DELETE_ALERT_SUCCESS;
export const HIDE_ALERT = PREFIX + '_' + PlayerConstants.HIDE_ALERT;
export const HIDE_ALERT_SUCCESS = PREFIX + '_' + PlayerConstants.HIDE_ALERT_SUCCESS;
export const NEW_HIDDEN_ALERT = PREFIX + '_' + PlayerConstants.NEW_HIDDEN_ALERT;

export const ADD_TO_BLACKLIST = PREFIX + '_' + PlayerConstants.ADD_TO_BLACKLIST;
export const SET_SETTINGS_AVERAGE_BOOKMAKERS = PREFIX + '_' + PlayerConstants.SET_SETTINGS_AVERAGE_BOOKMAKERS;


export const SET_SPORT_FILTER = SETTINGS + '_' + SettingConstants.SET_SPORT_FILTER;
export const SET_ORDER = SETTINGS + '_' + SettingConstants.SET_ORDER;
export const SET_SETTINGS = SETTINGS + '_' + SettingConstants.SET_SETTINGS;

export const MIN_LIMIT = -100;
export const MAX_LIMIT = 5;

export const DEFAULT_SETTINGS: PlayerSettingsObject = {
    bookmakers: [],
    comparisons: {
        '0': {
            status: true,
            margin: null,
            method: MarginMethod.NEW,
            threshold: -10,
            level0: 0,
            level1: -1,
            amountMarket: 0,
            amountOutcome: 0,
            booking: 0
        },
        '-1': {
            status: false,
            margin: null,
            method: MarginMethod.NEW,
            threshold: 5,
            level0: 0,
            level1: -1,
            amountMarket: 0,
            amountOutcome: 0,
            booking: 0
        },
        '2': {
            status: true,
            margin: null,
            method: MarginMethod.ORIGINAL,
            amountMarket: 0,
            amountOutcome: 0,
            threshold: 3,
            level0: 0,
            level1: -1,
            booking: 0
        }
    },
    date: 0,
    from: 1,
    to: 1,
    order: OrderConstants.COMPARISON,
    markets: [],
    sports: {1: true, 2: true, 5: true}
}